import { formatPhoneNumber } from "../../../util/formatPhoneNumber";

export const resolveDestinationMobile = (
  destinationMobile?: string | null,
  mobile?: string | null,
  phone?: string | null
) => formatPhoneNumber(String(destinationMobile || mobile || phone || ""));
